import * as Sentry from "@sentry/react";
import { useLocation } from "react-router-dom";

import { ContentContainer } from "features/layout/components";

import CrashPlaceholder from "common/components/CrashPlaceholder";
import useNavItems from "common/hooks/useNavItems";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";

import type { JSX, ReactNode } from "react";

export default function WorkspaceLayout({
  children,
  bannersComponent,
}: {
  children: ReactNode;
  bannersComponent: JSX.Element;
}) {
  const isDesktop = useTwBreakpoint("lg");
  const navItems = useNavItems();
  const location = useLocation();

  const LayoutComponent = isDesktop ? DesktopLayout : MobileLayout;

  return (
    <LayoutComponent navItems={navItems} bannersComponent={bannersComponent}>
      <Sentry.ErrorBoundary
        key={location.pathname}
        fallback={({ resetError, eventId }) => (
          <ContentContainer>
            <CrashPlaceholder resetError={resetError} eventId={eventId} />
          </ContentContainer>
        )}
      >
        {children}
      </Sentry.ErrorBoundary>
    </LayoutComponent>
  );
}
